export enum OriginApp {
  Backstage = 'backstage',
  Showtime = 'showtime',
  Dynamics = 'dynamics',
}
